import React from "react";
import { Box, Typography } from "@mui/material";

const PublicTestResultsFallback = ({ testCaseData }) => {
  return (
    <Box display="flex" gap={3} flexWrap="wrap">
      <Typography>
        <strong>Status:</strong> {testCaseData?.Status}
      </Typography>
      <Typography>
        <strong>Run Date:</strong> {testCaseData?.Executed_Date}
      </Typography>
      <Typography>
        <strong>Duration:</strong> {testCaseData?.Duration}
      </Typography>
      <Typography>
        <strong>Browser:</strong> {testCaseData?.Browser}
      </Typography>
    </Box>
  );
};

export default PublicTestResultsFallback;
